import { render, staticRenderFns } from "./GFDeregLeaverList.vue?vue&type=template&id=3ef0586b"
import script from "./GFDeregLeaverList.vue?vue&type=script&lang=js"
export * from "./GFDeregLeaverList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports